/**
 * Lib.Common: Device Properties
 */


const ios = /iP(hone|ad|od)\;/.test(navigator.userAgent) || (navigator.platform == 'MacIntel' && navigator.maxTouchPoints == 5);
const mobile = ios || /Android\;|Mobile( Safari)?\/|Mobile\;|Tablet\;/.test(navigator.userAgent);


export default {
    hasKeyboard: !mobile,
    hasMouse: !mobile,
    pixelRatio: window.devicePixelRatio || 1,

    ios,
    mobile: $build.platform == 'android' ? true
          : $build.platform == 'ios' ? true
          : $build.platform == 'desktop' ? false
          : mobile
};
